/**
 * `Ids` over the browser's crypto and nanoid.
 *
 * Both generators are kept exactly as they were rather than unified: entity
 * ids have always been uuids and task ids have always been nanoids, and those
 * strings are already in shipped databases and in `Idempotency-Key` records
 * the server holds for 48 hours. Changing either shape is a data migration,
 * not a tidy-up.
 */
import { nanoid } from 'nanoid';
import type { Ids } from '@kapture/platform';

export const webIds: Ids = {
  uuid: () => crypto.randomUUID(),
  taskId: () => nanoid(),
};
